<div class="modal-container-footer">
  <app-button (click)="modalRef.cancel()">Begrepen</app-button>
</div>
